import { createFileRoute, redirect } from "@tanstack/react-router";
import { serverAuth } from "@/data/auth";
import { HelpPage } from "@/features/publicinfo/HelpPage";

/** Public help centre. The slug is a help article, or `index` for the list of categories. Outside the _app layout.
 *  In server mode the public help centre is /help/<workspace slug> (it reads without a session), so this path forwards
 *  there: `index` opens the centre, any other slug opens that article. Sample mode keeps HelpPage. */
export const Route = createFileRoute("/p/help/$slug")({
  beforeLoad: async ({ params }) => {
    if (!serverAuth) return;
    const tenant = await readTenant();
    if (!tenant) return;
    throw redirect({
      to: "/help/$slug",
      params: { slug: tenant.slug },
      search: params.slug === "index" ? {} : { article: params.slug },
    });
  },
  component: HelpRoute,
});

/** The single tenant's public name and slug. A failed read returns null, and the page then draws as before. */
async function readTenant(): Promise<{ name: string; slug: string } | null> {
  try {
    const res = await fetch("/api/public/tenant");
    if (!res.ok) return null;
    return (await res.json()) as { name: string; slug: string };
  } catch {
    return null;
  }
}

function HelpRoute() {
  const { slug } = Route.useParams();
  return <HelpPage slug={slug} />;
}
